import BigNumber from "bignumber.js";

export const rounded = (amount: number, decimalPlaces = 2) =>
  BigNumber(amount).dp(decimalPlaces, BigNumber.ROUND_FLOOR).toNumber();

const ONE_CENT = 0.01;

/** ensures the stake is divisible by number of combinations and meets the 1c
 * per combo requirement */
export const safeExoticStake = (stake: number, combinations: number) => {
  if (stake === 0) return 0;
  const stakeInCents = rounded(stake * 100);

  if (stake / combinations < ONE_CENT) {
    // enforce 1c bet per combo as a minimum
    return ONE_CENT * combinations;
  }

  if (stakeInCents % combinations > 0) {
    const newStake = stakeInCents - (stakeInCents % combinations);
    return newStake / 100;
  } else {
    return stakeInCents / 100;
  }
};
